import React from 'react';
import ImageBanner from "./ImageBanner";

const TopProductSlider = () => {
    return (
        <div className="product-slider-header xpt-8">
            <div className="container">
                <div className="swiper product-slider-header-swiper">
                    <div className="title-product d-lg-none">
                        <h3>پیشنهاد طلایی امروز</h3>
                    </div>
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <a href="#">
                                <div
                                    className="box-product position-relative green xpt-6 xpb-1 xpl-4 xpr-4 xpl-sm-6 xpr-sm-6 xpb-lg-2">
                                    <div className="row">
                                        <div className="col-lg-7 xp-0">
                                            <div className="text-product">
                                                <h3>
                                                    هدفون بی‌سیم بیتس مدل
                                                    Studio 3 – The Beats Skyline Collection
                                                </h3>
                                                    <span className="button">بررسی و خرید</span>
                                            </div>
                                        </div>
                                        <div className="col-lg-5 xp-0">
                                            <div
                                                className="img-product d-flex justify-content-center align-items-center">
                                                <img src="./assets/sample-image/green-headphones-png-1.png"
                                                     alt="headphones" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="swiper-slide">
                            <a href="#">
                            <div
                                className="box-product position-relative yellow xpt-6 xpb-1 xpl-4 xpr-4 xpl-sm-6 xpr-sm-6 xpb-lg-2">
                                <div
                                    className="price position-absolute d-flex justify-content-between align-content-center">
                                    <span className="discount">2,700,562 ت</span>
                                    <span>۳،۲۹۰،۰۰۰ ت</span>
                                </div>
                                <div className="row">
                                    <div className="col-lg-7 xp-0">
                                        <div className="text-product">
                                            <h3>
                                                ایرپاد ۲ هندزفری بلوتوث نسل ۲ اپل با قابلیت شارژ بی‌سیم
                                            </h3>
                                                <span className="button">پیشنهاد طلایی</span>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 xp-0">
                                        <div
                                            className="img-product xmt-0 xmt-xl-4 d-flex justify-content-center align-items-center xmt-1">
                                            <img src="./assets/sample-image/MWP22.png"
                                                 alt="headphones" className="img-fluid"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </a>
                        </div>
                        <div className="swiper-slide">
                {/*            <a href="#">
                            <div
                                className="box-product position-relative orange xpt-6 xpb-1 xpl-4 xpr-4 xpl-sm-6 xpr-sm-6 xpb-lg-2">
                                <div
                                    className="price position-absolute d-flex justify-content-between align-content-center">
                                    <span className="discount">۲،۷۶۰،۰۰۰ ت</span>
                                    <span>۳،۲۹۰،۰۰۰ ت</span>
                                </div>
                                <div className="row">
                                    <div className="col-lg-7 xp-0">
                                        <div className="text-product">
                                            <h3>
                                                شیائومی می بند 5 نسخه گلوبال
                                            </h3>
                                                <span className="button">بررسی و خرید</span>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 xp-0">
                                        <div
                                            className="img-product xmt-6 d-flex justify-content-center align-items-center">
                                            <img src="./assets/sample-image/Mi-Band-5-removebg-preview.png"
                                                 alt="headphones" className="img-fluid"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </a>*/}
                            <ImageBanner/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopProductSlider;
